import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import ThemeToggle from './ThemeToggle';

const Navigation = ({ scrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { name: 'Home', to: 'hero' },
    { name: 'Approach', to: 'approach' },
    { name: 'Services', to: 'capabilities' },
    { name: 'Insights', to: 'about' },
  ];

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="hero" smooth={true} duration={800} offset={-80} className="nav-logo-link">
          <div className="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_22049afd-70cd-4eda-9ae4-f1c9d8a02585/artifacts/epd28g0n_ido-consulting-notext-large.png" 
              alt="IDO Logo" 
              className="logo-image"
              loading="lazy"
            />
            <div className="logo-text">
              <h3>IDO</h3>
              <span className="logo-tagline">Adaptive</span>
            </div>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <div className="nav-links desktop-nav">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              smooth={true}
              duration={800}
              offset={-80}
              className="nav-link"
            >
              {item.name}
            </Link>
          ))}
        </div>

        <div className="nav-cta desktop-nav">
          <ThemeToggle />
          <a 
            href="https://outlook.office.com/bookwithme/user/4526d5f0831940e5bde7b640ab309b68%40idoconsulting.ca?anonymous&ismsaljsauthenabled=true" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <Button className="contact-button">Connect</Button>
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              smooth={true}
              duration={800}
              offset={-80}
              className="mobile-nav-link"
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}
          <div className="mobile-menu-actions">
            <ThemeToggle />
            <a 
              href="https://outlook.office.com/bookwithme/user/4526d5f0831940e5bde7b640ab309b68%40idoconsulting.ca?anonymous&ismsaljsauthenabled=true" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ textDecoration: 'none', width: '100%' }}
            >
              <Button 
                className="contact-button mobile-contact"
                onClick={() => setMobileMenuOpen(false)}
              >
                Connect
              </Button>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;